"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseKey"));

// Copyright 2017-2020 @polkadot/util authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
if (typeof TextEncoder === 'undefined') {
  try {
    var _encoder, _temp;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-var-requires
    const {
      TextEncoder: UTE
    } = require('util'); // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-member-access


    global.TextEncoder = (_temp = (_encoder = (0, _classPrivateFieldLooseKey2.default)("encoder"), class {
      constructor() {
        Object.defineProperty(this, _encoder, {
          writable: true,
          value: void 0
        });
        (0, _classPrivateFieldLooseBase2.default)(this, _encoder)[_encoder] = new UTE();
      } // For a Jest 26.0.1 environment, Buffer !== Uint8Array


      encode(value) {
        const encoded = (0, _classPrivateFieldLooseBase2.default)(this, _encoder)[_encoder].encode(value);

        return Uint8Array.from(encoded);
      }

    }), _temp);
  } catch (error) {// noop
  }
}